module.exports = __webpack_public_path__ + "static/img/marmalade_pictgrid11_800x800.f375a83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marmalade_pictgrid11_800x800.jpg
// module id = nH3Q
// module chunks = 0